import React from "react";
import { Stack } from "@mui/system";
import TourCardSkeleton from "@/components/skeletons/tour-card-skeleton";

const TOUR_CARD_SKELETON_KEYS = [
  "tour-card-skeleton-a",
  "tour-card-skeleton-b",
  "tour-card-skeleton-c",
  "tour-card-skeleton-d"
];

const TourCardCarouselSkeleton = () => (
  <Stack
    direction="row"
    gap={3}
    sx={{ my: "2.5rem", overflow: "hidden" }}
    data-testid="tour-card-carousel-skeleton"
  >
    {TOUR_CARD_SKELETON_KEYS.map((skeletonKey) => (
      <TourCardSkeleton key={skeletonKey} />
    ))}
  </Stack>
);

export default TourCardCarouselSkeleton;
